"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TruncatedText = exports.Root = exports.OfferProductsWrapper = exports.OfferMessage = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isSingleOffer, theme } = param;
    return {
        padding: theme.spacing(6),
        width: 'auto',
        maxWidth: 980,
        marginBottom: theme.spacing(4),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.largeComponentRadius,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
        '&:last-child': {
            marginBottom: 0
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(4, 3),
            borderRadius: 0
        },
        [theme.breakpoints.up('sm')]: {
            ...isSingleOffer && {
                flexDirection: 'row',
                columnGap: theme.spacing(12),
                alignItems: 'center'
            }
        }
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isSingleOffer, theme } = param;
    return {
        alignItems: 'start',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            ...isSingleOffer && {
                flex: '1.65 1 0'
            }
        }
    };
});
const TruncatedText = exports.TruncatedText = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'maxLines'
    ])
})((param)=>{
    let { maxLines } = param;
    return {
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        '&:empty': {
            display: 'none'
        }
    };
});
const OfferMessage = exports.OfferMessage = (0, _mui.styled)(TruncatedText)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.offer.main
    };
});
const OfferProductsWrapper = exports.OfferProductsWrapper = (0, _mui.styled)('div')({
    position: 'relative'
});
